<template>
    <header>
        <div class="header-container">
            <div class="logo">
                <img src="@/assets/images/logo-healthid-lab_sbg.png" />
            </div>
        </div>
    </header>
</template>

<script>

    export default {
        name: "header-div",
        data() {
            return {

            }
        },
        methods: {

        },
        mounted() {

        }
    }
</script>

<style scoped>
    @import "./header.scss";
    @import "./responsive.css";
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue